import { useMutation, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { CustomerSsoConfigQueryKeys } from "./keys";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import { CreateUpdateSsoConfigRequest } from "../../models/CustomerSsoConfig/CustomerSsoConfig";

export default function useCustomerSsoConfigMutations(customerId: string) {
  const queryClient = useQueryClient();
  const { saveHandlers, deleteHandlers } = useDefaultCRUDHandlers("SSO Config");
  const { post, del } = useApiHelper();

  const createOrUpdate = useMutation({
    mutationFn: (config: CreateUpdateSsoConfigRequest) =>
      post(`/customer/${customerId}/sso`, config),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: CustomerSsoConfigQueryKeys.all(customerId),
      });
      saveHandlers.onSuccess();
    },
    onError: () => {
      saveHandlers.onError();
    },
  });

  const remove = useMutation({
    mutationFn: () => del(`/customer/${customerId}/sso`),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: CustomerSsoConfigQueryKeys.all(customerId),
      });
      deleteHandlers.onSuccess();
    },
    onError: () => {
      deleteHandlers.onError();
    },
  });

  return {
    createOrUpdate,
    remove,
  };
}
